// For Development
// export const API_URL = "https://dev.locksmithhub.net/api/admin";
// export const FILE_UPLOAD_API_URL = "https://dev.locksmithhub.net";

export const API_URL = "https://api.jobdashflash.com/api/admin";
export const FILE_UPLOAD_API_URL = "https://api.jobdashflash.com";


// For Production
// export const API_URL = "http://app.locksmithhub.net/api/admin";
// export const FILE_UPLOAD_API_URL = "http://app.locksmithhub.net";

export const GOOGLE_MAP_API_KEY = "AIzaSyANFvytlUdoF9WVD7zmQm5N9UhTF2FSjjc";
